import { render, staticRenderFns } from "./AlipayAuthLaunch.vue?vue&type=template&id=83378f4e&scoped=true"
import script from "./AlipayAuthLaunch.vue?vue&type=script&lang=js"
export * from "./AlipayAuthLaunch.vue?vue&type=script&lang=js"
import style0 from "./AlipayAuthLaunch.vue?vue&type=style&index=0&id=83378f4e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83378f4e",
  null
  
)

export default component.exports